import request from '@/utils/request'

let HomepushApi = {
  /*获取数据*/
  getData(data) {
    return request._get('/shop/plus.homepush/index', data);
  },
  /*保存数据*/
  saveData(data) {
    return request._post('/shop/plus.homepush/index', data);
  },
}
export default HomepushApi;



// WEBPACK FOOTER //
// ./src/api/homepush.js